var map = {
	"./screen-jaguar.jpg": 413,
	"./screen-jet2.jpg": 414,
	"./screen-jet2holidays.jpg": 415,
	"./screen-landrover.jpg": 416
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 419;



//////////////////
// WEBPACK FOOTER
// ./src/img ^\.\/screen\-.*\.jpg$
// module id = 419
// module chunks = 114276838955818